import type { GetStaticProps } from "next";
import Metadata from "~/components/metadata";
import Team from "~/components/team";
import client from "~/config/client";
import type { MemberCoreDataFragment } from "~/__generated__/graphql";
import { getSdk } from "~/__generated__/graphql";

type Props = {
  data: {
    members: MemberCoreDataFragment[];
    highlight?: MemberCoreDataFragment | null;
  };
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const { team } = await getSdk(client).TeamContents();
  const { members, highlight } = Object.assign(
    { members: [], highlight: null },
    team?.data?.attributes,
  );

  return {
    revalidate: 1,
    props: {
      data: {
        members,
        highlight,
      },
    },
  };
};

export default function TeamPage({ data }: Props) {
  return (
    <>
      <Metadata
        pageTitle="Advante Team"
        title="Meet the Advante Performance Coach Team"
        description="Advante believes in helping individuals discover their full potential. In order to have a productive team that delivers exceptional output a key component is always employee empowerment and support - an area often overlooked. Each member of the Advante team is eager to find areas of improvement in their coachees and is able to understand each team structure in order to provide maximum support."
        canonical="https://advante.co/team"
      />
      <Team data={data} />
    </>
  );
}
